// extracted by mini-css-extract-plugin
export var feedback = "styles-module--feedback--0b5a8";
export var stars = "styles-module--stars--6aab5";
export var thumbs = "styles-module--thumbs--0f7ae";